import { TranslateManagerService } from 'src/app/service/translate-manager/translate-manager.service'
import { Pipe, PipeTransform } from '@angular/core';
import { AuthService } from 'src/app/service/auth/auth.service';
import * as moment from 'moment-timezone';
import 'moment/locale/pt-br';
import 'moment/locale/en-ca';
import 'moment/locale/es-us';
import 'moment/locale/fr-ca';

@Pipe({
	name: 'datetime',
})
export class DatetimePipe implements PipeTransform {
	constructor(
		private authService: AuthService = null,
		private translateManager: TranslateManagerService
	) { }

	transform(value: any, format?: string): string {
		const language = this.translateManager.getCurrentLanguage()
		const languageParser = {
			'en': 'en-ca',
			'pt': 'pt-br',
			'es': 'es-us',
			'fr': 'fr-ca'
		}
		moment.locale(languageParser[language])
		if (!value) {
			return null;
		}
		if (!format) {
			format = 'MMM D, LT';
		}
		let dateTime = null;
		const user = this.authService.user;
		if (user && user.timezone) {
			dateTime = moment.utc(value).tz(user.timezone);
		} else {
			dateTime = moment.utc(value);
		}
		if (format.indexOf('calendar') >= 0) {
			value = dateTime.calendar();
			if (format === 'calendar-day' && value.indexOf('at') >= 0) {
				return value.split('at')[0].trim();
			} else if (format === 'calendar-time' && value.indexOf('at') >= 0) {
				return value.split('at')[1].trim();
			}
			return value;
		}
		return dateTime.format(format);
	}
}
